export enum CaseNotificationEvent {
  NEW_CASE_CREATED = "new_case_created",
  CASE_STATUS_UPDATED = "case_status_updated",
}
